import { API_URL } from "env";

export interface CommentCustomer {
    id: number;
    first_name: string;
    last_name: string;
    fullname: string;
    avatar: string;
}

export interface CommentItem {
    id: number;
    product_id: number;
    parent_id: number;
    customer_id: number;
    comment: string;
    created_at: string;
    updated_at: string;
    customer: CommentCustomer | null;
    children: CommentItem[];
}

export interface CommentListResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: CommentItem[];
    };
    msg: string;
}

export interface CreateCommentResponse {
    status: boolean;
    data: CommentItem;
    msg: string;
}

export async function fetchComments(productId: number, page: number = 1): Promise<CommentListResponse | null> {
    const url = `${API_URL}/api/v1/fe/comment_products?product_id=${productId}&page=${page}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            },
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error("Failed to fetch comments:", error);
        return null;
    }
}

export async function createComment(productId: number, comment: string, parentId: number = 0): Promise<CreateCommentResponse | null> {
    const url = `${API_URL}/api/v1/fe/comment_product?product_id=${productId}`;
    const token = localStorage.getItem('token');

    if (!token) {
        console.error("No token found for creating comment");
        return null;
    }

    try {
        const formData = new FormData();
        formData.append('comment', comment);
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: formData
        });
        console.log("Create comment response:", response);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const responseData = await response.json();
        console.log("Create comment response data:", responseData);
        return responseData;
    } catch (error) {
        console.error("Failed to create comment:", error);
        return null;
    }
}
